import { blackColors, whiteColor, defaultBodyFont } from 'assets/jss/material-dashboard-pro-react';

const customSelectorsStyle = {
	labelRoot: {
		padding: '8px',
	},
	labelDisabled: {
		color: `${blackColors[3]} !important`,
	},
	label: {
		cursor: 'pointer',
		paddingLeft: '0',
		color: blackColors[2],
		fontSize: '14px',
		lineHeight: '1.29',
		fontWeight: '400',
		display: 'inline-flex',
		...defaultBodyFont,
	},
	labelChecked: {
		color: blackColors[1],
	},
	labelCustomValues: (props) => ({
		fontWeight: props.fontWeight,
		color: props.color,
	}),
	disabledCheckboxAndRadio: {
		'& $checkedIcon,& $uncheckedIcon,& $radioChecked,& $radioUnchecked': {
			borderColor: blackColors[6],
			backgroundColor: whiteColor,
		},
	},
};

export default customSelectorsStyle;
